<template>
  <el-container id="app" v-cloak>
    <el-main v-if="isCallout || hideMenu">
      <router-view />
    </el-main>
    <template v-else>
      <crm-aside />
      <el-container>
        <el-header height="57px" v-if="!isIm">
          <crm-header ref="crmHeader" :hasStatus="isIm" :im-status="imStatus" :isIm="isIm" />
          <!-- <crm-note /> -->
        </el-header>
        <el-main :style="`position: relative;`">
          <keep-alive :include="['CallInLayout']">
            <router-view />
          </keep-alive>
        </el-main>
      </el-container>
    </template>
    <Dialog :dialog="dialog" />
  </el-container>
</template>

<script>
import CrmHeader from './container/CrmHeader'
import CrmAside from './container/CrmAside'
import CrmNote from './container/CrmNote'
import interval from '@/extend/interval.mixins'
import Dialog from '@/components/Dialog.vue'
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
import EventListen from '@/mixins/event.mixin'
import { IM_WORKBENCH_MAP } from '@/constant'
import { extendImports } from '@meta-vue/cx-workbench-descriptions'

export default {
  name: 'Layout',
  components: { CrmHeader, CrmAside, Dialog },
  mixins: [interval, EventListen],
  computed: {
    ...mapGetters('Authentication', ['UserInfo']),
    ...mapGetters('caller', ['CallerInfo']),
    ...mapGetters('app', ['imStatus', 'ImWorkBenchId']),
    isCallout() {
      return (
        (this.$route.name || '').includes('CallOut') ||
        (this.$route.name || '').includes('CrmCall') ||
        this.$route.query.hideMenu
      )
    },
    // 平台在线工作台
    isImRoute() {
      const { path } = this.$route
      return !!path?.startsWith('/im') && parseInt(this.ImWorkBenchId) === IM_WORKBENCH_MAP.ONLINE_IM
    },
    // 是否是电话 和 天润电话工作台
    isCallInRoute() {
      const { path } = this.$route
      return path?.match?.(/^(\/callin|\/tr_callin)/)
    }
  },
  watch: {
    $route: {
      // 检查im路由控制展示客服状态，和电话工作台区分
      handler(val, oldval) {
        if (val.path.indexOf('/im') !== -1) {
          this.isIm = true
        } else {
          this.isIm = false
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      locale: window?.antd?.locales?.zh_CN,
      status: 2,
      toggle: false,
      isIm: false,
      hideMenu: false
    }
  },
  methods: {
    ...mapActions('caller', ['getCallerAgent', 'getTrDevice', 'getTRCallInExtension']),
    ...mapActions('callUserConfig', ['initCallUserConfig']),
    ...mapActions('workbench', ['setWorkbenchSupportSimpleMode']),
    ...mapActions('app', ['getImWorkbenchInfo']),
    async init(isIMPage) {
      this.initCallUserConfig()
      // this.getTrDevice()
      // this.getTRCallInExtension()
      // await this.getCallerAgent()
      // await Avaya.setCallInit(this.CallerInfo.agentId, this.CallerInfo.deviceId, AVAYA_SOCKET_HOST, isIMPage, {
      //   ...this.UserInfo.user
      // }).then(() => {
      //   if (window.localStorage.getItem('_crm_avaya_status')) {
      //     this.statusChange(window.localStorage.getItem('_crm_avaya_status') + '')
      //   }
      // })
    },
    /** 电话工作台 切换状态  */
    // statusChange(val) {
    //   // 通知后端
    //   switch (val) {
    //     case '1': {
    //       Avaya.setCallFree(true)
    //       break
    //     }
    //     case '2': {
    //       Avaya.setCallLeave(true)
    //       break
    //     }
    //     case '3': {
    //       Avaya.setCallBusy(true)
    //       break
    //     }
    //     default:
    //       break
    //   }
    //   return false
    // },
    libTrackInit() {
      this.$libTrack.init({
        appType: '41',
        appId: 'qmove-customer-service-workbench',
        postfix: 'qmove-customer-service-workbench',
        userId: `${_.get(this.UserInfo, 'user.id')}`,
        // autoPrintLog: true,
        pageNameHandler() {
          let pageName =
            window.location.hash
              .substr(2)
              .split('?')[0]
              .replace(/-/g, '_')
              .toLowerCase()
              .replace(/\//g, '_')
              .replace(/_$/g, '') || 'home'
          if (pageName.startsWith('callin')) {
            pageName = 'callin_deprecated' // 这个页面手动埋点，自动埋点上传至无效埋点
          }
          return pageName.slice(0, 100)
        }
      })
    }
  },
  mounted() {
    this.getImWorkbenchInfo()
    // 呼出坐席在im页面是不初始化avaya
    const isIMPage = _.get(window, 'location.hash', '').includes('/im')
    if (window.frames.length === parent.frames.length) {
      this.init(isIMPage)
    } else {
      this.initCallUserConfig()
    }
    this.libTrackInit()
    const params = new URLSearchParams(window.location.hash?.split?.('?')?.[1])
    this.hideMenu = params.get('hideMenu') || false
    this.setWorkbenchSupportSimpleMode()
    extendImports({
      $createDialog: this.$createDialog.bind(this),
      $createDrawer: this.$createDrawer.bind(this)
    })
  }
}
</script>

<style lang="stylus" scoped>
#app
  background #f6f6f6
  height 100vh
  width 100vw
  overflow hidden
  display flex

.el-header
  padding 0
.el-main
  padding 0
  background-color #fff
</style>
<style lang="stylus">
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
::-webkit-scrollbar-track-piece {
  background-color: transparent; //滚动槽
  -webkit-border-radius: 2px;
}
::-webkit-scrollbar-thumb:vertical {
  height: 4px;
  background-color: #e4e4e4;
  -webkit-border-radius: 2px;
}
::-webkit-scrollbar-thumb:horizontal {
  width: 4px;
  background-color: #e4e4e4;
  -webkit-border-radius: 2px;
}
::-webkit-scrollbar-thumb:vertical:hover,::-webkit-scrollbar-thumb:horizontal:hover
{
  background-color: #BDBDBD;
}
</style>
